import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.scss']
})

export class PublicComponent implements OnInit {

    userFirstName: any;
  
    constructor(public userService: UserService, 
                public router: Router) {
        if (this.userService.isFullyAuthenticated()) {
            if (this.userService.currentUser.cgu == true) {
                this.router.navigate(['/cgu']);
            } else {
                this.router.navigate(['/folders', this.userService.currentUser.symfonyUser.defaultFolder]);
            }
        } else {
            this.userService.login();
        }
    }

    ngOnInit(): void {}
}
